import { render, staticRenderFns } from "./greenfilmdocs.vue?vue&type=template&id=4bc3c440&scoped=true&"
import script from "./greenfilmdocs.vue?vue&type=script&lang=js&"
export * from "./greenfilmdocs.vue?vue&type=script&lang=js&"
import style0 from "./greenfilmdocs.vue?vue&type=style&index=0&id=4bc3c440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc3c440",
  null
  
)

export default component.exports